<template>
  <el-dialog :title="`模板详情(${clibInfo.vacFieldLibName})`"
    :visible.sync="visible"
    width="500px"
    @closed='handleClosed'
    :close-on-press-escape="false">
    <el-form label-width="80px"
      v-if="clibInfo.fieldCode === 'wxPublicAccount'">
      <el-form-item label="公众号:">{{clibInfo.wxAccount}}</el-form-item>
      <el-form-item label="二维码:">
        <upload-image status="detail"
          v-model="clibInfo.accountQRCodeImage"
          :limit="1" />
      </el-form-item>
    </el-form>
    <el-form label-width="80px"
      v-else>
      <el-form-item label="导航名:">{{clibInfo.fieldName}}</el-form-item>
      <el-form-item label="图文:">
        <desc-images :edit="false"
          v-model="clibInfo.fieldList" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="toggleModal(false)"
        :loading="loading">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import UploadImage from '@/components/public/upload-image-new.vue'
import DescImages from '@/components/public/desc-images.vue'
export default {
  name: 'clib-detail-modal',
  components: { UploadImage, DescImages },
  props: {},
  data () {
    return {
      loading: false,
      visible: false,
      clibInfo: {},
      vendorInfo: {}
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClosed () {
      this.$nextTick(() => {
        this.clibInfo = {}
      })
    },
    getvaclib (vacFieldLibId, vendorId) {
      this.loading = true
      this.$store.dispatch('vas/getvaclib', {
        payload: {
          vendorId,
          vacFieldLibId
        },
        success: (res) => {
          this.loading = false
          res.data.fieldValue = JSON.parse(res.data.fieldValue)
          if (res.data.fieldCode === 'wxPublicAccount') {
            this.clibInfo = {
              vacFieldLibName: res.data.vacFieldLibName,
              fieldCode: res.data.fieldCode,
              wxAccount: res.data.fieldValue.account,
              accountQRCodeImage: res.data.fieldValue.accountQRCodeImage ? res.data.fieldValue.accountQRCodeImage.split(',').map(item => ({
                url: item
              })) : []
            }
          } else {
            this.clibInfo = {
              vacFieldLibName: res.data.vacFieldLibName,
              fieldCode: res.data.fieldCode,
              fieldName: res.data.fieldName,
              fieldList: res.data.fieldValue.multiMedias.map(item => ({ id: item.id, name: item.name, mediaType: item.mediaType, url: item.content }))
            }
          }
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('vendor/applyvendor', {
            payload: {
              ...this.vendorInfo,
              businessLicenceFile: this.vendorInfo.businessLicenceFile.map(item => item.url).join(',')
            },
            success: (res) => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
